import { CAMERA_SETTINGS } from './config';
import type { GameProgress, GameState } from './types';

export function createGameProgress(): GameProgress {
  return {
    level: 1,
    score: 0,
    credits: 240,
    weapon: 'electro',
    unlocked: { electro: true, flame: false, rocket: false },
    upgrades: { power: 0, cooling: 0, shield: 0 },
    cameraMode: 'top',
    cameraSettings: { ...CAMERA_SETTINGS },
    difficulty: 'normal',
    musicTrack: 'city',
    musicVolume: 0.2,
    soundVolume: 0.2,
    sound: true,
    completed: false,
    gameOver: false,
  };
}

export function createGameState(): GameState {
  return {
    ...createGameProgress(),
    running: false,
    paused: false,
    startedAt: 0,
    elapsed: 0,
    wave: 1,
    waveTotal: 4,
    spawned: 0,
    waveKills: 0,
    baseHp: 100,
    baseMaxHp: 100,
    playerHp: 100,
    playerMaxHp: 100,
    playerShieldTime: 0,
    baseShieldTime: 0,
    dropCooldown: 8,
    dropsCollected: 0,
    victory: false,
    playerX: 0,
    playerZ: 6,
    playerHeading: 0,
    aimX: 0,
    aimZ: 0,
    aimHeading: 0,
    fireCooldown: 0,
    gridCol: 8,
    gridRow: 10,
    gridMove: null,
    input: { forward: false, back: false, left: false, right: false, fireHeld: false, order: [] },
    spawnCooldown: 0.7,
    levelTransition: 0,
    waveStarted: false,
  };
}
